export enum RecommendationActionType {
  // Create
  CreateRecommendationTemplate          = 'CREATE_RECOMMENDATION_TEMPLATE',
  CreateRecommendationTemplateCompleted = 'CREATE_RECOMMENDATION_TEMPLATE_COMPLETED',
  CreateRecommendationTemplateFailed    = 'CREATE_RECOMMENDATION_TEMPLATE_FAILED',

  // Create
  CreateRecommendationTemplateRule          = 'CREATE_RECOMMENDATION_TEMPLATE_RULE',
  CreateRecommendationTemplateRuleCompleted = 'CREATE_RECOMMENDATION_TEMPLATE_RULE_COMPLETED',
  CreateRecommendationTemplateRuleFailed    = 'CREATE_RECOMMENDATION_TEMPLATE_RULE_FAILED',

  // Create
  CreateRecommendationCategory          = 'CREATE_RECOMMENDATION_CATEGORY',
  CreateRecommendationCategoryCompleted = 'CREATE_RECOMMENDATION_CATEGORY_COMPLETED',
  CreateRecommendationCategoryFailed    = 'CREATE_RECOMMENDATION_CATEGORY_FAILED',

  // Update
  UpdateEmployeeRecommendation          = 'UPDATE_EMPLOYEE_RECOMMENDATION',
  UpdateEmployeeRecommendationCompleted = 'UPDATE_EMPLOYEE_RECOMMENDATION_COMPLETED',
  UpdateEmployeeRecommendationFailed    = 'UPDATE_EMPLOYEE_RECOMMENDATION_FAILED',

  // Update
  UpdateRecommendationTemplate          = 'UPDATE_RECOMMENDATION_TEMPLATE',
  UpdateRecommendationTemplateCompleted = 'UPDATE_RECOMMENDATION_TEMPLATE_COMPLETED',
  UpdateRecommendationTemplateFailed    = 'UPDATE_RECOMMENDATION_TEMPLATE_FAILED',

  // Update
  UpdateRecommendationTemplateRule          = 'UPDATE_RECOMMENDATION_TEMPLATE_RULE',
  UpdateRecommendationTemplateRuleCompleted = 'UPDATE_RECOMMENDATION_TEMPLATE_RULE_COMPLETED',
  UpdateRecommendationTemplateRuleFailed    = 'UPDATE_RECOMMENDATION_TEMPLATE_RULE_FAILED',


  // Update
  UpdateRecommendationCategory          = 'UPDATE_RECOMMENDATION_CATEGORY',
  UpdateRecommendationCategoryCompleted = 'UPDATE_RECOMMENDATION_CATEGORY_COMPLETED',
  UpdateRecommendationCategoryFailed    = 'UPDATE_RECOMMENDATION_CATEGORY_FAILED',

  // Load
  LoadEmployeeRecommendations           = 'LOAD_EMPLOYEE_RECOMMENDATIONS',
  LoadEmployeeRecommendationsCompleted  = 'LOAD_EMPLOYEE_RECOMMENDATIONS_COMPLETED',
  LoadEmployeeRecommendationsFailed     = 'LOAD_EMPLOYEE_RECOMMENDATIONS_FAILED',

  // Load
  LoadRecommendationTemplate            = 'LOAD_RECOMMENDATION_TEMPLATE',
  LoadRecommendationTemplateCompleted   = 'LOAD_RECOMMENDATION_TEMPLATE_COMPLETED',
  LoadRecommendationTemplateFailed      = 'LOAD_RECOMMENDATION_TEMPLATE_FAILED',

  // Load
  LoadRecommendationsLibrary            = 'LOAD_RECOMMENDATION_LIBRARY',
  LoadRecommendationsLibraryCompleted   = 'LOAD_RECOMMENDATION_LIBRARY_COMPLETED',
  LoadRecommendationsLibraryFailed      = 'LOAD_RECOMMENDATION_LIBRARY_FAILED',

  // Load
  LoadAssessmentQuestions            = 'LOAD_ASSESSMENT_QUESTIONS',
  LoadAssessmentQuestionsCompleted   = 'LOAD_ASSESSMENT_QUESTIONS_COMPLETED',
  LoadAssessmentQuestionsFailed      = 'LOAD_ASSESSMENT_QUESTIONS_FAILED',

  // Select
  SelectEmployeeRecommendation          = 'SELECT_RECOMMENDATION',
  SelectEmployeeRecommendationCompleted = 'SELECT_RECOMMENDATION_COMPLETED',
  SelectEmployeeRecommendationFailed    = 'SELECT_RECOMMENDATION_FAILED',

  // Delete
  DeleteEmployeeRecommendation          = 'DELETE_EMPLOYEE_RECOMMENDATION',
  DeleteEmployeeRecommendationCompleted = 'DELETE_EMPLOYEE_RECOMMENDATION_COMPLETED',
  DeleteEmployeeRecommendationFailed    = 'DELETE_EMPLOYEE_RECOMMENDATION_FAILED',

  // Delete
  DeleteRecommendationTemplate          = 'DELETE_RECOMMENDATION_TEMPLATE',
  DeleteRecommendationTemplateCompleted = 'DELETE_RECOMMENDATION_TEMPLATE_COMPLETED',
  DeleteRecommendationTemplateFailed    = 'DELETE_RECOMMENDATION_TEMPLATE_FAILED',

  // Delete
  DeleteRecommendationTemplateRule          = 'DELETE_RECOMMENDATION_TEMPLATE_RULE',
  DeleteRecommendationTemplateRuleCompleted = 'DELETE_RECOMMENDATION_TEMPLATE_RULE_COMPLETED',
  DeleteRecommendationTemplateRuleFailed    = 'DELETE_RECOMMENDATION_TEMPLATE_RULE_FAILED',

  // Delete
  DeleteRecommendationCategory          = 'DELETE_RECOMMENDATION_CATEGORY',
  DeleteRecommendationCategoryCompleted = 'DELETE_RECOMMENDATION_CATEGORY_COMPLETED',
  DeleteRecommendationCategoryFailed    = 'DELETE_RECOMMENDATION_CATEGORY_FAILED',

}
